import { constants as PrimaryButton } from '../PrimaryButton';
import { constants as PlainButton } from '../PlainButton';
import { constants as AddButton } from '../AddButton';
import { constants as SecondaryButton } from '../SecondaryButton';
import { getFontFamily, getFontWeight } from '../../typography/typography.alias';
import { getBorderRadius } from '../../borders/borders.alias';
import { VARIANT_PRIMARY_MEDIUM, VARIANT_PRIMARY_SMALL, VARIANT_PLAIN_MEDIUM, VARIANT_PLAIN_SMALL, VARIANT_ADD, VARIANT_SECONDARY, VARIANT_PLAIN_LARGE, VARIANT_PRIMARY_LARGE, ELEMENT_BUTTON, INTERACTION_STATE_HOVER, INTERACTION_STATE_ACTIVE, INTERACTION_STATE_FOCUS_VISIBLE, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Button',
    variants: {
        VARIANT_PRIMARY_LARGE,
        VARIANT_PRIMARY_MEDIUM,
        VARIANT_PRIMARY_SMALL,
        VARIANT_PLAIN_LARGE,
        VARIANT_PLAIN_MEDIUM,
        VARIANT_PLAIN_SMALL,
        VARIANT_ADD,
        VARIANT_SECONDARY,
    },
    elements: {
        ELEMENT_BUTTON,
    },
    interactionStates: {
        INTERACTION_STATE_ACTIVE,
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
});
export default function getButton(transformer, config) {
    const fontFamily = getFontFamily(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const fontWeight = getFontWeight(transformer);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_BUTTON]: {
                styles: {
                    borderRadius: borderRadius.button.value,
                    fontFamily: fontFamily.button.value,
                    fontWeight: fontWeight.button.get(fontFamily.button.value),
                },
                variants: {
                    [VARIANT_PRIMARY_LARGE]: {
                        components: {
                            [PrimaryButton.NAME]: {
                                variant: PrimaryButton.variants.VARIANT_LARGE,
                            },
                        },
                    },
                    [VARIANT_PRIMARY_SMALL]: {
                        components: {
                            [PrimaryButton.NAME]: {
                                variant: PrimaryButton.variants.VARIANT_SMALL,
                            },
                        },
                    },
                    [VARIANT_PLAIN_LARGE]: {
                        components: {
                            [PlainButton.NAME]: {
                                variant: PlainButton.variants.VARIANT_LARGE,
                            },
                        },
                    },
                    [VARIANT_PLAIN_SMALL]: {
                        components: {
                            [PlainButton.NAME]: {
                                variant: PlainButton.variants.VARIANT_SMALL,
                            },
                        },
                    },
                    [VARIANT_PLAIN_MEDIUM]: {
                        components: {
                            [PlainButton.NAME]: {
                                variant: PlainButton.variants.VARIANT_MEDIUM,
                            },
                        },
                    },
                    [VARIANT_PRIMARY_MEDIUM]: {
                        components: {
                            [PrimaryButton.NAME]: {
                                variant: PrimaryButton.variants.VARIANT_MEDIUM,
                            },
                        },
                    },
                    [VARIANT_ADD]: {
                        components: {
                            [AddButton.NAME]: {
                                variant: AddButton.variants.VARIANT_DEFAULT,
                            },
                        },
                    },
                    [VARIANT_SECONDARY]: {
                        components: {
                            [SecondaryButton.NAME]: {
                                variant: SecondaryButton.variants.VARIANT_DEFAULT,
                            },
                        },
                    },
                },
            },
        },
    });
}
